import { CreateWebRedirectDto as CreateWebRedirectModel } from '@goparrot/webstore-sdk';

(CreateWebRedirectModel as any).prototype.init = function (options: Partial<CreateWebRedirectModel>) {
  Object.assign(this, options);
  return this;
};

export { CreateWebRedirectModel };
